import React from "react";

import { Box, Card, CardContent, Container, Grid, Skeleton } from "@mui/material"
import { styled } from "@mui/styles"

const MainCard = styled(Card)({
  backgroundColor: "#fff",
  borderRadius: "12px",
  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  border: "1px solid #e5e7eb",
})

export default function CommonPaginateSkeleton({ marginInline, simple = false, loading = false, count = 3, hasPaginate = true }) {
  const customMaxWidth = !!marginInline ? false : "lg";
  const customPx = !!marginInline ? "0 !important" : 3;

  const ArticleCardSkeletonItem = ({ isLast }) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        px: 2.5,
        py: 4,
        borderBottom: isLast ? 'none' : `1px solid #f0f0f0`,
      }}>
      {/* Icon */}
      <Skeleton variant="rounded" width={44} height={44} sx={{ borderRadius: 2, flexShrink: 0 }} />

      {/* Content */}
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 0.75 }}>
        <Skeleton variant="text" width="55%" height={18} />
        <Skeleton variant="text" width="30%" height={14} />
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 0.25 }}>
          <Skeleton variant="circular" width={14} height={14} />
          <Skeleton variant="text" width={60} height={14} />
        </Box>
      </Box>

      {/* Chevron */}
      <Skeleton variant="rounded" width={8} height={14} sx={{ borderRadius: 0.5, flexShrink: 0 }} />
    </Box>
  );

  if (!loading) return <></>;

  if (simple) {
    return (
      <Grid container item xs={12} sm={12} sx={{ marginInline: marginInline }}>
        <Container maxWidth={customMaxWidth} sx={{ py: 2, px: customPx, flex: 1, display: "flex", flexDirection: "column" }}>
          <MainCard sx={{ mb: 3, flex: 1 }}>
            <Box sx={{ display: "flex", flexDirection: "row", gap: 2, p: 3 }}>
              <Skeleton variant="rounded" width={48} height={48} style={{ borderRadius: 12 }} />

              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Skeleton variant="text" width={220} height={28} />
                <Skeleton variant="text" width={160} height={16} />
              </Box>
            </Box>

            {Array.from({ length: count }).map((_, i) => (
              <ArticleCardSkeletonItem key={i} isLast={i === count - 1} />
            ))}
          </MainCard>

          {hasPaginate && (
            <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
              <Box sx={{ display: "flex", gap: 1, mr: 8 }}>
                <Skeleton variant="rounded" width={30} height={30} animation="wave" sx={{ borderRadius: "8px" }} />
                <Skeleton variant="rounded" width={30} height={30} animation="wave" sx={{ borderRadius: "8px" }} />
                <Skeleton variant="rounded" width={30} height={30} animation="wave" sx={{ borderRadius: "8px" }} />
              </Box>

              <Skeleton variant="text" width={150} height={24} animation="wave" />
            </Box>
          )}
        </Container>
      </Grid>
    );
  }

  return (
    <Box sx={{ display: "flex", flex: 1, flexDirection: "column", gap: 2 }}>
      <MainCard sx={{ mb: 3, flex: 1 }}>
        <CardContent sx={{ display: "flex", flex: 1, gap: 3, p: 3, }}>
          {/* Lista de Itens (Esquerda) */}
          <Box sx={{ width: "30%", display: "flex", flexDirection: "column", gap: 2, pr: 2 }}>
            <Skeleton variant="text" width="90%" height={24} animation="wave" />
            <Skeleton variant="text" width="80%" height={24} animation="wave" />
            <Skeleton variant="text" width="70%" height={24} animation="wave" />
            <Skeleton variant="text" width="85%" height={24} animation="wave" />
            <Skeleton variant="text" width="75%" height={24} animation="wave" />
          </Box>

          {/* Área de Conteúdo (Direita) */}
          <Box sx={{ width: "70%", display: "flex", flexDirection: "column", gap: 2 }}>
            <Skeleton variant="text" width="100%" height={20} animation="wave" />
            <Skeleton variant="text" width="95%" height={20} animation="wave" />
            <Skeleton variant="text" width="60%" height={20} animation="wave" />
            <Skeleton variant="rounded" width={150} height={100} animation="wave" sx={{ my: 2 }} />
            <Skeleton variant="text" width="100%" height={20} animation="wave" />
            <Skeleton variant="text" width="90%" height={20} animation="wave" />
            <Skeleton variant="rounded" width={150} height={100} animation="wave" sx={{ my: 2 }} />
            <Skeleton variant="text" width="85%" height={20} animation="wave" />
          </Box>
        </CardContent>
      </MainCard>

      {/* Paginação */}
      {hasPaginate && (
        <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
          <Box sx={{ display: "flex", gap: 1, mr: 8 }}>
            <Skeleton variant="rounded" width={30} height={30} animation="wave" sx={{ borderRadius: "8px" }} />
            <Skeleton variant="rounded" width={30} height={30} animation="wave" sx={{ borderRadius: "8px" }} />
            <Skeleton variant="rounded" width={30} height={30} animation="wave" sx={{ borderRadius: "8px" }} />
          </Box>

          <Skeleton variant="text" width={150} height={24} animation="wave" />
        </Box>
      )}
    </Box>
  )
}